import { styled } from '@mui/material';

export const SectionContainer = styled('div')`
  margin-bottom: 24px;
`;

export const ProductInfoStyled = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  overflow: 'hidden',
  gap: '10px',
  flexDirection: 'row',
  alignItems: 'flex-start',
  height: 'fit-content !important',
  margin: '0 auto',
  maxWidth: '1400px',
  '@media only screen and (max-width: 768px)': {
    flexDirection: 'column',
    gap: '0px',
  },
}));
